import BaseHttp from './BaseHttp';
import config from '../../config/app.config';
const EXPORT_CONFIGS_URI = 'configs/export';
// because only when we create or update export config the image code field called `code` but in other cases called `image_code`
const prepareImageCodes = (imageCodes) => {
    return imageCodes.map(({ image_code, ...imageCode }) => ({
        ...imageCode,
        code: image_code
    }));
};
class ImageExportConfigsApi extends BaseHttp {
    constructor(config) {
        super(config);
    }
    getExportConfigs() {
        return this.privateRequest('GET', EXPORT_CONFIGS_URI);
    }
    getExportConfig(id) {
        return this.privateRequest('GET', `${EXPORT_CONFIGS_URI}/${id}`);
    }
    createExportConfig(exportConfig) {
        const { imageCodes, ...config } = exportConfig;
        const data = config;
        data.imageCodes = prepareImageCodes(imageCodes);
        return this.privateRequest('POST', EXPORT_CONFIGS_URI, data);
    }
    updateExportConfig(exportConfig) {
        const { id, imageCodes, advertisingImages, exportBackgroundImages, wall, floor, watermark, auto_de_watermark, wallImage, floorImage, watermarkImage, autoDeWatermarkImage, ...config } = exportConfig;
        const data = config;
        data.imageCodes = prepareImageCodes(imageCodes);
        if (wallImage) {
            data.wallImage = wallImage.id;
        }
        if (floorImage) {
            data.floorImage = floorImage.id;
        }
        if (watermarkImage) {
            data.watermarkImage = watermarkImage.id;
        }
        else if (watermark) {
            data.watermarkImage = null;
        }
        if (autoDeWatermarkImage) {
            data.autoDeWatermarkImage = autoDeWatermarkImage.id;
        }
        else if (auto_de_watermark) {
            data.autoDeWatermarkImage = null;
        }
        return new Promise((resolve, reject) => {
            this.privateRequest('PUT', `${EXPORT_CONFIGS_URI}/${id}`, data)
                .then(() => resolve())
                .catch(reject);
        });
    }
    deleteExportConfig({ id }) {
        return this.privateRequest('DELETE', `${EXPORT_CONFIGS_URI}/${id}`);
    }
    deleteBackgroundImage({ id }) {
        return this.privateRequest('DELETE', `${EXPORT_CONFIGS_URI}/background/${id}`);
    }
    uploadBackgroundImage(exportConfigId, file, appointment) {
        const formData = new FormData();
        formData.append('appointment', appointment);
        formData.append('backgroundFile', file, file.name);
        return this.privateRequest('POST', `${EXPORT_CONFIGS_URI}/${exportConfigId}/background`, formData, {
            'Content-Type': 'multipart/form-data'
        });
    }
}
export default new ImageExportConfigsApi({
    baseURL: config.profileAPI.url
});
